import React from 'react';

class Retailer extends React.Component {
	handleClick() {
		global.dataLayer.push({
			event: 'Where to Buy',
			eventCategory: 'Where to Buy',
			eventAction: 'Product Page Click',
			eventLabel: `${this.props.retailer.name} - Model ${this.props.productModelNumber}`
		});
	}

	render() {
		const { retailer } = this.props;
		return (
			<li>
				<div className="retailer-logo">
					<img
						src={ retailer.logo }
						alt={ retailer.name }
					/>
				</div>
				<h2 className="retailer-name">{ retailer.name }</h2>
				<a
					className="arrow-link"
					onClick={ () => this.handleClick() }
					href={ retailer.purchaseLink }
					target="_blank"
				>
					Buy Now
				</a>
			</li>
		);
	}
}

export default Retailer;


// WEBPACK FOOTER //
// ./src/pages/product/Retailer.js